import { DEFAULT_STATE_VALUES } from "@/shared/constants/common";
import type { PEADState } from "./types";

export const PEAD = {
	LINE: {
		AVG: "Avg",
		MAX: "Max",
		MIN: "Min",
		PRICE: "Price",
		SIGMA_1: "S 1",
		SIGMA_2: "S 2",
		SIGMA_MINUS_1: "S -1",
		SIGMA_MINUS_2: "S -2",
	},

	LINE_COLOR: {
		AVG: "#d5b972",
		MAX: "#339933",
		MIN: "#cc3300",
		PRICE: "#0962e7",
		SIGMA_1: "#4d4e50",
		SIGMA_2: "#4d4e50",
		SIGMA_MINUS_1: "#4d4e50",
		SIGMA_MINUS_2: "#4d4e50",
		DEFAULT: "#d5b972",
	},

	END_LABEL_COLOR: {
		AVG: "#f1f516",
		MAX: "#339933",
		MIN: "#cc3300",
		PRICE: "#0962e7",
		SIGMA_1: "#d5b972",
		SIGMA_2: "#d5b972",
		SIGMA_MINUS_1: "#d5b972",
		SIGMA_MINUS_2: "#d5b972",
	},

	WATERMARK_COLOR: "#c3c3c3",
	LAST_4_QTR_COLOR: "#33ccff",
	CURRENT_PEAD_COLOR: "var(--gold)",
	DEFAULT_PEAD_COLOR: "gray",
};

export const tableMap = {
	before_ed: "ED-1",
	ed_close: "ED Close",
	after_ed_open: "ED+1 Open",
	after_ed_close: "ED+1 Close",
	qtr_end: "Qtr End",
	"7d": "ED+7",
	"20d": "ED+20",
	"70d": "ED+70",
};

export const NO_DATA = "N/A";
export const SMALL_CHART_HEIGHT = "200px";
export const MAIN_CHART_HEIGHT = "400px";

export const initialPeadValues = {
	ticker: DEFAULT_STATE_VALUES.ticker,
	peadFilter: "PEAD",
	historyType: "Last",
	qtr: "20 Qtr",
	stdDev: false,
	relativeToSpy: false,
} as const satisfies PEADState;
